import React, {useEffect, useState} from "react";
import Home from "./Home";
import {Routes, Route, Link, useNavigate, useLocation, Navigate} from "react-router-dom";
import Contacto from "./Contacto";
import Iniciar_sesion from "./Iniciar_sesion";
import Header from "./Header";
import Footer from "./Footer";
import Preguntas_PER from "./Preguntas_PER";
import Ver_preguntas from "./Ver_preguntas";
import Estadisticas from "./Estadisticas";
import { UserProvider } from './UserContext';
import Cambiar from "./Cambiar";
import Politica_cookies from "./Politica_cookies";

const Router = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [userPermissions, setUserPermissions] = useState(
        JSON.parse(localStorage.getItem('userPermissions')) || null
    );
    const navigate = useNavigate();
    const location = useLocation();

    const handleLoginSuccess = (permissions) => {
        console.log('Login successful:', permissions);
        setUserPermissions(permissions);
        localStorage.setItem('userPermissions', JSON.stringify(permissions));
        navigate('/'); // Redirige a la página de inicio
    };    

    return (
        <>
            <Header userPermissions={userPermissions} />
            <UserProvider userPermissions={userPermissions}>
            <Routes>
                <Route path="/" element={<Home />}/>
                <Route path="contacto" element={<Contacto />} />
                <Route path="login" element={<Iniciar_sesion onLoginSuccess={handleLoginSuccess} />} />
                <Route path="logout" element={<Navigate to="/" replace />} />
                <Route path="preguntas_per" element={<Preguntas_PER />} />
                <Route path="ver_preguntas" element={<Ver_preguntas />}/>
                <Route path="estadisticas_per" element={<Estadisticas />}/>
                <Route path="politica_cookies" element={<Politica_cookies />}/>
                <Route path="cambiar" element={<Cambiar />}/>
            </Routes>
            </UserProvider>
            <Footer />
        </>
    );
};

export default Router;
